import { Drawer, IconButton, Typography, Divider, SxProps, Grid } from "@mui/material";
import React, { useState } from "react";
import { map } from "lodash";
import { Close } from "@mui/icons-material";
import NoteCard from "./NoteCard";
import DrawerFilters from "./DrawerFilters";
import CreateNoteModal from "./CreateNoteModal";
import { useQuery } from "@apollo/client/react";
import { GetPersonalNotesQuery, GetPersonalNotesDocument } from "@/graphql/generated/graphql";

const DEFAULT_FILTERS = {
  search: "",
  noteType: "",
  tagIds: []
}

interface NotesDrawerProps {
  open: boolean;
  onClose: () => void;
  sx?: SxProps;
}

const NotesDrawer: React.FC<NotesDrawerProps> = ({ open, onClose, sx = {} }) => {
  const [currentNote, setCurrentNote] = useState<NonNullable<GetPersonalNotesQuery['getPersonalNotes']>[0] | null>(null);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const { data } = useQuery(GetPersonalNotesDocument, {
    fetchPolicy: "cache-and-network",
    variables: {
      ...Object.fromEntries(
        Object.entries(filters)
          .filter(([_, value]) => value !== "")
      ),
    }
  });

  return (
    <Drawer open={open} onClose={onClose} anchor="right" variant="persistent" sx={{ textAlign: "initial", ...sx }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid container direction="column" sx={{ py: 1.5, px: 2 }} size="grow">
          <Typography variant="h5"> Notes </Typography>
          <Typography variant="caption"> Collection of all notes for your account </Typography>
        </Grid>
        <Grid sx={{ textAlign: 'right' }} size={2}>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ mr: 2, color: (theme) => theme.palette.grey[500] }}
          >
            <Close />
          </IconButton>
        </Grid>
      </Grid>
      <Divider />
      <DrawerFilters
        filters={filters}
        onChange={(key, value) => {
          setFilters((prev) => ({
            ...prev,
            [key]: value
          }));
        }}
      />
      <Grid container alignContent='flex-start' size={12}>
        {map(data?.getPersonalNotes, (note, index) => (
          <NoteCard
            note={note}
            onClick={() => setCurrentNote(note)}
            key={`notes-list-${note.id}-${index}`}
          />
        ))}
      </Grid>
      {
        currentNote && (
          <CreateNoteModal
            handleClose={() => setCurrentNote(null)}
            currentNote={currentNote}
          />
        )
      }
    </Drawer >
  );
};

export default NotesDrawer;
